module.exports = __webpack_public_path__ + "img/胡颖.923e0716.jpg";